import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const CHANGE_PRIORITY_SUCCESS = "CHANGE_PRIORITY_SUCCESS";
export const CHANGE_PRIORITY_ERROR = "CHANGE_PRIORITY_ERROR";

// Thunk Action Creator
export const changePriorityOfTask = createAsyncThunk(
    "api/Task/changePriority",
    async (json, { dispatch }) => {
        try {
            const online = navigator.onLine;

            if (online) {
                console.group('📤 changePriorityOfTask - Sending to server');
                console.log('Request payload:', { id: json.id, priority: json.priority, priorityUpdates: json.priorityUpdates });
                
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/changePriority/${json.id}`,
                    {
                        id: json.id,
                        priority: json.priority,
                        priorityUpdates: json.priorityUpdates
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        const tasks = response.data.tasks || response.data;
                        console.log('📦 Server response - Task count:', tasks?.length);
                        
                        // Find and log the changed task's priority in the response
                        const findTask = (items, id) => {
                            if (!items) return null;
                            for (const item of items) {
                                if (item.id === id) return item;
                                if (item.children) {
                                    const found = findTask(item.children, id);
                                    if (found) return found;
                                }
                            }
                            return null;
                        };
                        const changedTask = findTask(tasks, json.id);
                        console.log('📦 Changed task in response:', changedTask ? { 
                            title: changedTask.title, 
                            globalPriority: changedTask.globalPriority,
                            sentPriority: json.priority,
                            match: changedTask.globalPriority === json.priority
                        } : 'NOT FOUND');
                        
                        idb.storeTaskList(tasks);
                    }
                }
                else {
                    console.error('❌ Server returned error status:', response.status);
                    console.groupEnd();
                    throw Error("Error changing priority of task");
                }

                dispatch({
                    type: CHANGE_PRIORITY_SUCCESS,
                    payload: response.data,
                });
            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: CHANGE_PRIORITY_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: CHANGE_PRIORITY_ERROR, payload: error });
            await signOut();
        }
        
        //.then(response => {
        //    dispatch({
        //        type: CHANGE_PRIORITY_SUCCESS,
        //        payload: response.data,
        //    });
        //    dispatch(getLatestTaskList());
        //})
        //.catch(error => {
        //    dispatch({ type: CHANGE_PRIORITY_ERROR, payload: error });
        //});
    }
);
